import { render, staticRenderFns } from "./darkLinkDetection.vue?vue&type=template&id=d928bf10&scoped=true&"
import script from "./darkLinkDetection.vue?vue&type=script&lang=js&"
export * from "./darkLinkDetection.vue?vue&type=script&lang=js&"
import style0 from "./darkLinkDetection.vue?vue&type=style&index=0&id=d928bf10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d928bf10",
  null
  
)

export default component.exports